import Vue from 'vue'
import VueRouter from 'vue-router'

import top from '../components/member/top.vue'
import login from '../components/member/login.vue'
import cancel from '../components/member/cancel.vue'

import form from '../components/member/form/index.vue'
import formProductInput from '../components/member/form/productInput.vue'
import formProductConfirm from '../components/member/form/productConfirm'
import formSms from '../components/member/form/sms.vue'
import formSearch from '../components/member/form/search.vue'
import formUserInput from '../components/member/form/userInput.vue'
import formSigin from '../components/member/form/sigin.vue'
import formUpload from '../components/member/form/upload.vue'
import formPdfIssue from '../components/member/form/pdfIssue.vue'
import formDone from '../components/member/form/done.vue'

import listWrap from '../components/member/list/wrap.vue'
import listList from '../components/member/list/list.vue'

import listDetail from '../components/member/list/detail.vue'

import passwordReset from '../components/member/password/reset.vue'

import documentDownload from '../components/member/document/download.vue'
import registPhoto from '../components/member/list/photo/regist.vue'
import updateProduct from '../components/member/list/product/update.vue'
import updateCustomer from '../components/member/list/customer/update.vue'

export default new VueRouter({
    mode: 'history',
    routes: [
        // トップページ
        { path: '/', component: top, name: 'top' },

        // ログイン
        { path: '/login', component: login, name: 'login' },

        // 申込み 新規・追加・変更
        {
            path: '/form',
            component: form,
            children: [{
                    path: 'product-input',
                    component: formProductInput,
                    name: 'form-product-input'
                },
                {
                    path: 'product-confirm',
                    component: formProductConfirm,
                    name: 'form-product-confirm'
                },
                { path: 'sms', component: formSms, name: 'form-sms' },
                { path: 'search', component: formSearch, name: 'form-search' },
                {
                    path: 'user-input',
                    component: formUserInput,
                    name: 'form-user-input'
                },
                { path: 'sigin', component: formSigin, name: 'form-sigin' },
                { path: 'upload', component: formUpload, name: 'form-upload' },
                {
                    path: 'pdf-issue',
                    component: formPdfIssue,
                    name: 'form-pdf-issue'
                },
                { path: 'done', component: formDone, name: 'form-done' }
            ],
            beforeEnter: (to, from, next) => {
                if (from.name === 'top' || from.name === 'list-detail') {
                    if (to.name === 'form-product-input') {
                        next()
                    } else {
                        alert('申込み画面には戻ることができません。最初からやり直してください。')
                        next({ name: 'top' })
                    }
                    // アプラスCallback
                } else if (from.name === null && to.name === 'form-done') {
                    next()
                } else {
                    next({ name: 'top' })
                }
            }
        },

        // キャンセル時のページ
        { path: '/cancel', component: cancel, name: 'cancel' },

        // ご契約一覧
        {
            path: '/list',
            component: listWrap,
            children: [{
                path: '',
                component: listList,
                name: 'list',
                children: [{
                        path: 'detail/:id',
                        component: listDetail,
                        name: 'list-detail'
                    },
                    {
                        path: 'photo/regist/:id',
                        component: registPhoto,
                        name: 'regist-photo'
                    },
                    {
                        path: 'product/update-product/:id',
                        component: updateProduct,
                        name: 'update-product'
                    },
                    {
                        path: 'product/update-customer/:id',
                        component: updateCustomer,
                        name: 'update-customer'
                    }
                ]
            }]
        },

        // パスワードリセット
        {
            path: '/password-reset',
            component: passwordReset,
            name: 'password-reset'
        },

        // 各種書籍
        {
            path: '/document-download',
            component: documentDownload,
            name: 'document-download'
        }
    ]
})